export default class Roles {

    static userHasAnyOfRoles (user, roles) {
        if (!user || !roles) return false;

        for(let i = 0; i < roles.length; i++) {
            if(user.roles.indexOf(roles[i]) !== -1) {
                return true;
            }
        }

        return false;
    }

    static userHasAllOfRoles (user, roles) {
        if (!user || !roles) return false;

        for(let i = 0; i < roles.length; i++) {
            if(user.roles.indexOf(roles[i]) === -1) {
                return false;
            }
        }

        return true;
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/utils/roles.js
 **/